import { Tooltip } from '@mui/material';
import { ImageTooltipStyles, TooltipStyles } from './tooltip.styles';

interface Props {
  id: string;
  value: string;
  minCharacters: number;
  className?: string;
  child: any;
}

interface ImageTooltipProps {
  id: string;
  value: any;
  className?: string;
  child: any;
}

export function TextTooltip(props: Props) {
  return (
    <Tooltip
      className={props.className}
      id={`${props.id}-tooltip`}
      placement='top'
      componentsProps={TooltipStyles}
      title={props.value ?? ''}
      disableFocusListener
      disableHoverListener={props.value ? props.value.length < props.minCharacters : false}
    >
      {props.child}
    </Tooltip>
  );
}

export function ImageTooltip(props: ImageTooltipProps) {
  return (
    <Tooltip
      className={props.className}
      id={`pic-tooltip-${props.id}`}
      placement='right-end'
      componentsProps={ImageTooltipStyles}
      title={props.value}
    >
      {props.child}
    </Tooltip>
  );
}
